var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import InputBase from '../InputBase';
import { useEffect, useState } from 'react';
import colors from '../../themes/colors';
import TagsInputTag from './TagsInput.Tag';
var TagsWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n\n  min-height: 36px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  padding: 4px 8px;\n\n  & .MuiFormControl-root {\n    flex: 1 1 200px;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n\n  min-height: 36px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  padding: 4px 8px;\n\n  & .MuiFormControl-root {\n    flex: 1 1 200px;\n  }\n"])), colors.white, colors.neutral60);
var CloseIcon = function (props) { return (_jsxs("svg", __assign({}, props, { style: { cursor: 'pointer', marginRight: -10 }, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("g", __assign({ clipPath: "url(#clip0_965_6970)" }, { children: _jsx("path", { d: "M11.1751 9.99916L15.6001 5.58249C15.677 5.5032 15.72 5.3971 15.72 5.28666C15.72 5.17622 15.677 5.07012 15.6001 4.99083L15.0001 4.39916C14.9208 4.32229 14.8147 4.2793 14.7043 4.2793C14.5939 4.2793 14.4878 4.32229 14.4085 4.39916L10.0001 8.82416L5.58347 4.39916C5.50418 4.32229 5.39808 4.2793 5.28764 4.2793C5.1772 4.2793 5.0711 4.32229 4.9918 4.39916L4.40014 4.99916C4.32326 5.07845 4.28027 5.18456 4.28027 5.295C4.28027 5.40543 4.32326 5.51154 4.40014 5.59083L8.82514 9.99916L4.40014 14.4158C4.32326 14.4951 4.28027 14.6012 4.28027 14.7117C4.28027 14.8221 4.32326 14.9282 4.40014 15.0075L4.9918 15.5992C5.0711 15.676 5.1772 15.719 5.28764 15.719C5.39808 15.719 5.50418 15.676 5.58347 15.5992L10.0001 11.1742L14.4168 15.5992C14.4961 15.676 14.6022 15.719 14.7126 15.719C14.8231 15.719 14.9292 15.676 15.0085 15.5992L15.6001 15.0075C15.677 14.9282 15.72 14.8221 15.72 14.7117C15.72 14.6012 15.677 14.4951 15.6001 14.4158L11.1751 9.99916Z", fill: "#192121" }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_965_6970" }, { children: _jsx("rect", { width: "20", height: "20", fill: "white" }) })) })] }))); };
var TagsInput = function (props) {
    var tags = props.tags, onTagsChange = props.onTagsChange, validateTag = props.validateTag;
    var _a = useState(''), value = _a[0], setValue = _a[1];
    var _b = useState(false), focused = _b[0], setFocused = _b[1];
    var _c = useState([]), errors = _c[0], setErrors = _c[1];
    var validateErrors = function (ts) { return setErrors(ts.map(function (t) { var _a; return (_a = validateTag === null || validateTag === void 0 ? void 0 : validateTag(t)) !== null && _a !== void 0 ? _a : false; })); };
    var onKeyPress = function (e) {
        window.setTimeout(function () {
            var addActions = ['Enter', 'Tab', 'Space', 'Comma'];
            var isAddAction = addActions.includes(e.code);
            var isBackspace = e.code === 'Backspace';
            var isEscape = e.code === 'Escape';
            if (isAddAction && value !== '') {
                var newTags = __spreadArray(__spreadArray([], tags, true), [value], false);
                onTagsChange(newTags);
                setValue('');
            }
            if (isBackspace && value === '') {
                var newTags = tags.slice(0, -1);
                onTagsChange(newTags);
            }
            if (isEscape) {
                setValue('');
            }
        });
    };
    var onRemoveTag = function (tag) {
        var newTags = tags.filter(function (t) { return t !== tag; });
        onTagsChange(newTags);
    };
    var onInputBlur = function () {
        setFocused(false);
    };
    var onInputFocus = function () {
        setFocused(true);
    };
    var clearInput = function () {
        setValue('');
    };
    useEffect(function () {
        validateErrors(tags);
    }, [tags]);
    return (_jsxs(TagsWrapper, { children: [tags.map(function (tag, i) { return (_jsx(TagsInputTag, { onRemove: onRemoveTag, tag: tag, isError: errors[i] }, "".concat(i.toString(), "_").concat(tag))); }), _jsx(InputBase, __assign({ type: "text", controlled: true, value: value, variant: "standard", onChange: setValue, onKeyPress: onKeyPress, fullWidth: true, size: "small", onBlur: onInputBlur, onFocus: onInputFocus, endAdornment: focused ? _jsx(CloseIcon, { onClick: clearInput }) : undefined }, props))] }));
};
export default TagsInput;
var templateObject_1;
